import React, { useState } from "react";
import { data, useNavigate } from "react-router-dom";
import "../styles/Refund.css";

const RefundForm = () => {
  const [orderId, setOrderId] = useState("");
  const [bookingDetails, setBookingDetails] = useState(null);
  const [refundEligible, setRefundEligible] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [requiresConfirmation, setRequiresConfirmation] = useState(false);
  const [leaveForHotel, setLeaveForHotel] = useState(false);

  const navigate = useNavigate();

  // **Fetch Booking Details**
  const fetchBookingDetails = async () => {
    setError("");
    setMessage("");
    if (!orderId.trim()) {
      setError("Order ID is required.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/payment/refund`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ razorpay_order_id: orderId }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setError(data.message || "Failed to fetch booking details.");
        return;
      }

      setBookingDetails(data.bookingDetails);
      setRefundEligible(data.bookingDetails?.refundEligible || "");
      setRequiresConfirmation(data.requiresConfirmation);
      setMessage(data.message)
    } catch (err) {
      setError("Server error! Please try again.", data.message);
    }
  };

  // **Confirm Cancellation**
  const confirmCancellation = async () => {
    setIsProcessing(true);
    setError("");
    setMessage("Your refund request is being processed please wait...");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/payment/refund`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            razorpay_order_id: orderId,
            confirmCancellation: true,
            leaveForHotel,
          }),
        }
      );

      const data = await response.json();
      
      if (!response.ok) {
        setError(data.message || "Failed to process refund.");
        setIsProcessing(false);
        return;
      }

      setRequiresConfirmation(data.requiresConfirmation)
      setMessage(data.message);

     //Check if refund ID exists before sending an email
    const {refundId, amountRefunded, refundDate } = data;

    if (refundId && amountRefunded > 0) {
      const emailResponse = await fetch(
        `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/sendreceiptrefund`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refundDetails: { refundId, amountRefunded, refundDate } }),
        }
      );

      console.log(refundDate)
      console.log(refundId)
      console.log(amountRefunded)

      const emailData = await emailResponse.json();
      if (!emailResponse.ok) {
        console.error("Failed to send refund email:", emailData.message);
      } else {
        setMessage("Refund request submitted successfully. Refund will be processed within 2-3 working days.");
      }
    }
    } catch (err) {
      setError("Server error! Please try again.");
    }

    setIsProcessing(false);
  };

  return (
    <div className="refund-overlay">
      <div className="refund-content">
        <h2>Cancel Your Booking</h2>

        <label htmlFor="orderId">Enter Your Order ID</label>
        <input type="text" id="orderId" value={orderId} onChange={(e) => setOrderId(e.target.value)} placeholder="e.g. order_12345"
          disabled={isProcessing || requiresConfirmation}
          required
        />
        {!bookingDetails && !message && <button type="button" className="refund-button" onClick={fetchBookingDetails} disabled={isProcessing}>
          Submit
        </button>}

        {message && <p className="success status-message">{message}</p>}

        {/* **Booking Details Section** */}
        {bookingDetails && !isProcessing && (
          <div className="booking-details">
            <h2>Booking for {bookingDetails.type}</h2>
            <p><b>Rooms:</b> {bookingDetails.numberOfRooms}</p>
            <p><b>Guests:</b> {bookingDetails.numberOfGuest}</p>
            <p><b>Mobile:</b> {bookingDetails.mobileNumber}</p>
            <p><b>Email:</b> {bookingDetails.email}</p>
            {bookingDetails.guest?.map((guest, index) => (
              <div className="guest-details" key={index}>
                <p><b>Guest {index + 1}:</b> {guest.name}</p>
                <p><b>Age:</b> {guest.age}</p>
                <p><b>Aadhar:</b> {guest.aadhar}</p>
              </div>
            ))}

            <div className="guest-details">
              <p><b>Country:</b> {bookingDetails.address.country}</p>
              <p><b>State:</b> {bookingDetails.address.state}</p>
              <p><b>Disrict:</b> {bookingDetails.address.district}</p>
              <p><b>City:</b> {bookingDetails.address.city}</p>
              <p><b>Pincode:</b> {bookingDetails.address.pincode}</p>
            </div>

            <p><b>Check-In:</b> {bookingDetails.checkInDate?.slice(0, 10) || "N/A"}</p>
            <p><b>Check-Out:</b> {bookingDetails.checkOutDate?.slice(0, 10) || "N/A"}</p>
            <p><b>Amount Paid:</b> ₹{bookingDetails.amount}</p>
            <p><b>Status:</b> {bookingDetails.status}</p>
            <p><b>Refund Info:</b> {refundEligible}{" "}
              {refundEligible?.includes("days") && (
              <>
                as per{" "}
                <a href="https://hotelshyampalaceghangaria.com/terms_and_conditions" target="_blank" rel="noreferrer">
                  Cancellation and Refund Policy
                </a>
              </>
            )}</p>

            {requiresConfirmation && (
             <>
             {refundEligible.includes('No refund') ? "" 
             : <div className="donate-box">
               <label>
                 <input type="checkbox" checked={leaveForHotel} onChange={(e) => setLeaveForHotel(e.target.checked)}/>
                 Donate refund to the hotel
               </label>
             </div>}
               <button className="refund-button" onClick={confirmCancellation} disabled={isProcessing}>
                  Confirm Cancellation
               </button>
             </>
           )}
          </div>
        )}
        {isProcessing && (
          <div className="loading-container">
          <div className="spinner"></div>
          </div>
        )}
        {error && <p className="error status-message">{error}</p>}
        {!isProcessing && message && !error && <>
          {!requiresConfirmation ? <button onClick={() => navigate("/")} className="refund-button">Done</button> : ""}
          </>}
      </div>
    </div>
  );
};

export default RefundForm;
